import {  Box, Flex, Text } from '@chakra-ui/react';
import {  useCallback } from 'react'
import { useNavigate } from 'react-router-dom';

//import { useMutation } from 'urql'
//import { INCREMENT_STREAK_MUTATION } from '../graphql/index'
//import { getIcon } from '../utils/index'

const colors = [
  'tomato',
  'green.400',
  'yellow.300',
  'cornflowerblue',
  'antiquewhite',
  'aquamarine',
  'lightpink',
  'navajowhite',
  'red.500',
  'lightcoral'
]

export const DashBoardCard = ({cardDetails }) => {
  const { id, index, route, icon } = cardDetails;
  const bgColor = colors[index % colors.length];
  //const [res, executeMutation] = useMutation(INCREMENT_STREAK_MUTATION) // eslint-disable-line no-unused-vars
  const navigate = useNavigate();
  
  const handleClick=useCallback(() => {
   
    navigate(route);
  }, [navigate]);
  

  return (
    
    <Flex
      align='center'
      justify='flex-end'
      direction='column'
      bg={bgColor}
      width={['40%',160,200]}
      height='150px'
      borderRadius='40px'
      margin='16px'
      padding='16px'
      boxShadow={'md'}
      cursor='pointer'
      onClick={handleClick}
    >

      <Box as={icon} size='64px' py={2}/>
      <Text fontWeight='hairline' fontSize='xl' textAlign='center'>
        {id}
        </Text>
        {/*<Badge
          as='span'
          fontWeight='hairline'
          fontSize='xl'
          rounded='full'
          mx='2'
          px='3'
          textTransform='lowercase'
          
          
        >
         gfg
  </Badge>*/}
       
    </Flex>
    
  )
}